
import Authentication from '../../components/authentication';
export default function LoginSocials(props) {
    return(
        <Authentication {...props} />
    )
}